// eslint-disable-next-line import/prefer-default-export
export const SORT_ATTRIBUTE_REPLACES = {
  restriction: 'mainGroup',
  onLine: 'status',
  code: 'id',
};

export const MODE_FULL = 'full';
export const MODE_LIST = 'list';
